import { conformToMask } from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
const phoneNumberMask = [
    '(',
    /[2-9]/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];
const zipcodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export { conformToMask, createNumberMask, phoneNumberMask, zipcodeMask };
//# sourceMappingURL=inputMasks.js.map